import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import PlantillaScreen from "../helpers/PlantillaScreen";
import SimuladorIncentivosFormVendedor from "./SimuladorIncentivosForm";
import SimuladorIncentivosGerenteScreen from "./SimuladorIncentivosGerenteScreen";
import SimuladorIncentivosRefaccionesScreen from "./SimuladorIncentivosRefaccionesScreen";
import SimuladorIncentivosTecnicoServicio from "./SumuladorIncentivosTecnicoServicio";
import SimuladorIncentivosCoordinadorMaquinariaUsada from "./SimuladorIncentivosCoordinadorMaquinariaUsada";
import SimuladorIncentivosPosventaScreen from "./SimuladorIncentivosPosventaScreen";
import SimuladorIncentivosCobranzaScreen from "./SimuladorIncentivosCobranzaScreen";
import SimuladorIncentivosJefeTaller from "./SimuladorIncentivosJefeTaller";
import SimuladorIncentivosFerreteriaScreen from "./SimuladorIncentivosFerreteriaScreen";
import SimuladorIncentivosSistemasRiegoScreen from "./SimuladorIncentivosSistemasRiegoScreen";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import CalculateIcon from "@mui/icons-material/Calculate";
import { LoaderScreen } from "../components/LoaderScreen";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { Button } from "@mui/material";
import ModalVisualizacionPDF from "./Modales/ModalVisualizacionPDF";

export const SimuladorIncentivosScreen = () => {
  const history = useHistory();
  const [titulo, setTitulo] = useState(
    "SIMULADOR DE INCENTIVOS PARA VENDEDOR INTEGRAL"
  );

  const [itemselected, setItemSelected] = useState(0);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarAyuda, setMostrarAyuda] = useState(false);

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [rolusuario, setRolUsuario] = useState([]);
  // const [rolusuario, setRolUsuario] = useState([
  //   { rol: "SMVI" },
  //   { rol: "SMGS" },
  //   { rol: "SMAR" },
  //   { rol: "SMTS" },
  //   { rol: "SMCU" },
  //   { rol: "SMCO" },
  //   { rol: "SMCP" },
  //   { rol: "SMJT" },
  // ]);

  const [roles] = useState([
    { rol: "SMVI" },
    { rol: "SMGS" },
    { rol: "SMAR" },
    { rol: "SMAF" },
    { rol: "SMAS" },
    { rol: "SMTS" },
    { rol: "SMCU" },
    { rol: "SMCO" },
    { rol: "SMCP" },
    { rol: "SMJT" },
  ]);

  const mapaRutas = {
    SMVI: { ruta: "/SI/Vendedor_integral", titulo: "SIMULADOR DE INCENTIVOS PARA VENDEDOR INTEGRAL" },
    SMGS: { ruta: "/SI/Gerente_sucursal", titulo: "SIMULADOR DE INCENTIVOS PARA GERENTE DE SUCURSAL" },
    SMAR: { ruta: "/SI/Asesor_refacciones", titulo: "SIMULADOR DE INCENTIVOS PARA ASESOR DE MOSTRADOR" },
    SMAF: { ruta: "/SI/Asesor_ferreteria", titulo: "SIMULADOR DE INCENTIVOS PARA ASESOR DE FERRETERIA" },
    SMAS: { ruta: "/SI/Asesor_sistemas_riego", titulo: "SIMULADOR DE INCENTIVOS PARA ASESOR DE SISTEMAS DE RIEGO" },
    SMTS: { ruta: "/SI/Tecnico_servicio", titulo: "SIMULADOR DE INCENTIVOS PARA TECNICO DE SERVICIO" },
    SMCU: { ruta: "/SI/Coordinador_usados", titulo: "SIMULADOR DE INCENTIVOS PARA COORDINADOR DE MAQUINARIA USADA" },
    SMCP: { ruta: "/SI/Coordinador_posventa", titulo: "SIMULADOR DE INCENTIVOS PARA COORDINADOR DE POSVENTA" },
    SMCO: { ruta: "/SI/cobranza", titulo: "SIMULADOR DE INCENTIVOS PARA EJECUTIVO Y COORDINADOR DE COBRANZA" },
    SMJT: { ruta: "/SI/Jefe_Taller", titulo: "SIMULADOR DE INCENTIVOS PARA JEFE DE TALLER" },
  };


  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get("SimuladorIncentivos/Obtener_Roles")
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setRolUsuario(result);


        // Ordena los roles del usuario según el orden definido
        const rolesOrdenados = result
          .filter((r) => roles.some((rolObj) => rolObj.rol === r.rol))
          .sort(
            (a, b) =>
              roles.findIndex((rolObj) => rolObj.rol === a.rol) -
              roles.findIndex((rolObj) => rolObj.rol === b.rol)
          );

        // Si el usuario tiene al menos un rol válido
        if (rolesOrdenados.length > 0) {
          const primerRol = rolesOrdenados[0].rol;
          const index = roles.findIndex((r) => r.rol === primerRol);

          // Asignamos el item seleccionado según su posición
          setItemSelected(index);

          // Navegar automáticamente según el rol
          const { ruta, titulo } = mapaRutas[primerRol] || {};
          if (ruta && titulo) {
            setTitulo(titulo);
            history.push(ruta);
          }
        }

        const tieneRolSMCD = result.some((r) => r.rol === "SMCD");
        setMostrarAyuda(tieneRolSMCD);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SIMULADOR INCENTIVOS", JSON.stringify(error), "warning");
      });
  }, []);


  const getclass = (item, rol) => {
    if (!rolusuario.some((x) => x.rol === rol))
      return "simulador_incentivo-aside-display-none";

    if (itemselected === item) return "simulador_incentivo-aside-item-selected";
    else return "simulador_incentivo-aside-item";
  };

  if (!roles.some((u) => rolusuario.some((x) => u.rol === x.rol)))
    return <div>No cuentas con permisos para acceder a esta pantalla</div>;


  const onAgregar = (id) => {
    setMostrarModal(true)
  }
  return (
    <PlantillaScreen
      titulo={titulo}
      className={"simulador_incentivos"}
      className_main={1}
    >
      <div className="simulador_incentivos_container">
        <LoaderScreen loader={loader} />

        <ModalVisualizacionPDF
          onClose={() => setMostrarModal(false)}
          open={mostrarModal}
          idrol={roles[itemselected]?.rol || "SMVI"}
          titulo={titulo}
          mostrarAyuda={mostrarAyuda}
        />

        <div className="simulador-incentivos-actions ">
          <div className="buttons">
            <div className='paquete-servicio-boton-agregar-container'>
              <button
                variant="contained"
                className='simulador-incentivos-boton-ayuda'
                onClick={() => onAgregar(-1)}
              >
                <HelpOutlineIcon />
                Boletin
              </button>
            </div>
          </div>
        </div>

        <div className="simulador_incentivo-aside">
          <div
            className={getclass(0, "SMVI")}
            onClick={() => {
              history.push("/SI/Vendedor_integral");
              setTitulo("SIMULADOR DE INCENTIVOS PARA VENDEDOR INTEGRAL");
              setItemSelected(0);
            }}
          >
            <CalculateIcon />
            Vendedor Integral
          </div>
          <div
            className={getclass(1, "SMGS")}
            onClick={() => {
              history.push("/SI/Gerente_sucursal");
              setTitulo("SIMULADOR DE INCENTIVOS PARA GERENTE DE SUCURSAL");
              setItemSelected(1);
            }}
          >
            <CalculateIcon />
            Gerente de sucursal
          </div>
          <div
            className={getclass(2, "SMAR")}
            onClick={() => {
              history.push("/SI/Asesor_refacciones");
              setTitulo(
                "SIMULADOR DE INCENTIVOS PARA ASESOR DE MOSTRADOR"
              );
              setItemSelected(2);
            }}
          >
            <CalculateIcon />
            Asesor de Mostrador
          </div>
          <div
            className={getclass(3, "SMAF")}
            onClick={() => {
              history.push("/SI/Asesor_ferreteria");
              setTitulo(
                "SIMULADOR DE INCENTIVOS PARA ASESOR DE FERRETERIA"
              );
              setItemSelected(3);
            }}
          >
            <CalculateIcon />
            Asesor de Ferreteria
          </div>
          <div
            className={getclass(4, "SMAS")}
            onClick={() => {
              history.push("/SI/Asesor_sistemas_riego");
              setTitulo(
                "SIMULADOR DE INCENTIVOS PARA ASESOR DE SISTEMAS DE RIEGO"
              );
              setItemSelected(4);
            }}
          >
            <CalculateIcon />
            Asesor de Sistemas de Riego
          </div>
          <div
            className={getclass(5, "SMTS")}
            onClick={() => {
              history.push("/SI/Tecnico_servicio");
              setTitulo("SIMULADOR DE INCENTIVOS PARA TECNICO DE SERVICIO");
              setItemSelected(5);
            }}
          >
            <CalculateIcon />
            Técnico de servicio
          </div>
          <div
            className={getclass(6, "SMCU")}
            onClick={() => {
              history.push("/SI/Coordinador_usados");
              setTitulo(
                "SIMULADOR DE INCENTIVOS PARA COORDINADOR DE MAQUINARIA USADA"
              );
              setItemSelected(6);
            }}
          >
            <CalculateIcon />
            Coordinador de maquinaria usada
          </div>
          <div
            className={getclass(7, "SMCP")}
            onClick={() => {
              history.push("/SI/Coordinador_posventa");
              setTitulo("SIMULADOR DE INCENTIVOS PARA COORDINADOR DE POSVENTA");
              setItemSelected(7);
            }}
          >
            <CalculateIcon />
            Coordinador de posventa
          </div>
          <div
            className={getclass(8, "SMCO")}
            onClick={() => {
              history.push("/SI/cobranza");
              setTitulo(
                "SIMULADOR DE INCENTIVOS PARA EJECUTIVO Y COORDINADOR DE COBRANZA"
              );
              setItemSelected(8);
            }}
          >
            <CalculateIcon />
            Ejecutivo y Coordinador de cobranza
          </div>
          <div
            className={getclass(9, "SMJT")}
            onClick={() => {
              history.push("/SI/Jefe_Taller");
              setTitulo("SIMULADOR DE INCENTIVOS PARA JEFE DE TALLER");
              setItemSelected(9);
            }}
          >
            <CalculateIcon />
            Jefe de taller
          </div>
        </div>
        <div className="simulador_incentivo-form">
          <div className="simulador_inventivo-form-container">
            <Route
              path="/SI/Vendedor_integral"
              component={() => (
                <SimuladorIncentivosFormVendedor puesto="Vendedor Integral" />
              )}
            />
            <Route
              path="/SI/Gerente_sucursal"
              component={() => (
                <SimuladorIncentivosGerenteScreen puesto="Gerente Sucursal" />
              )}
            />
            <Route
              path="/SI/Asesor_refacciones"
              component={() => (
                <SimuladorIncentivosRefaccionesScreen puesto="Asesor Refacciones" />
              )}
            />
            <Route
              path="/SI/Asesor_ferreteria"
              component={() => (
                <SimuladorIncentivosFerreteriaScreen puesto="Asesor Ferreteria" />
              )}
            />
            <Route
              path="/SI/Asesor_sistemas_riego"
              component={() => (
                <SimuladorIncentivosSistemasRiegoScreen puesto="Asesor Sistemas Riego" />
              )}
            />
            <Route
              path="/SI/Tecnico_servicio"
              component={() => (
                <SimuladorIncentivosTecnicoServicio puesto="Tecnico Servicio" />
              )}
            />
            <Route
              path="/SI/Coordinador_usados"
              component={() => (
                <SimuladorIncentivosCoordinadorMaquinariaUsada puesto="Coordinador Maquinaria Usada" />
              )}
            />
            <Route
              path="/SI/Coordinador_posventa"
              component={() => (
                <SimuladorIncentivosPosventaScreen puesto="Coordinador Posventa" />
              )}
            />
            <Route
              path="/SI/cobranza"
              component={() => (
                <SimuladorIncentivosCobranzaScreen puesto="Ejecutivo y Coordinador Posventa" />
              )}
            />
            <Route
              path="/SI/Jefe_Taller"
              component={() => (
                <SimuladorIncentivosJefeTaller puesto="Ejecutivo y Coordinador Posventa" />
              )}
            />
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
